export enum InputType {
  RADIO = 1,
  SLIDER = 2,
}

export enum InvitationStatus {
  AWAITING = 1,
  RESPONDED = 2,
}

export interface IQuestionType {
  instructions: string;
  inputType: InputType;
  keys: Array<string>;
  minValue: number;
  maxValue: number;
  step: number;
}

export interface IIndicator {
  id: number;
  indicatorName: string;
  indicatorType: string;
}

export type IQuestion = {
  id: number;
  questionText: string;
};

export type TAnswer = {
  value: number | null;
  comment: string | null;
};

export type TAnswers = {
  [questionId: number]: TAnswer;
};

export interface ISurveySection {
  questionType: IQuestionType;
  questionGroups: { [key: string]: IQuestionGroup };
}

export interface IQuestionGroup {
  indicator: IIndicator;
  questions: IQuestion[];
}

export interface ISurvey {
  [key: string]: ISurveySection;
}
